// Deliberately a plain object, not a Zustand store: this is written from the
// WebRTC data channel and read from a 120ms audio-analysis interval. Neither
// belongs in React state — a re-render per sample would be absurd, and nothing
// renders off these values directly.
export const audioLatencyStore = {
  // Pending user turns, oldest first. Pushed on conversation.item.created,
  // shifted when the first audible sample of the reply lands.
  queue: [],
  // Completed measurements, in ms.
  latencies: [],
  // Whether the RMS monitor currently sees signal (drives rising-edge detection).
  signalPresent: false,
  // OpenAI said audio is coming; we're waiting to actually hear it.
  firstAudiblePending: false,
};

export const resetAudioLatencyStore = () => {
  audioLatencyStore.queue = [];
  audioLatencyStore.latencies = [];
  audioLatencyStore.signalPresent = false;
  audioLatencyStore.firstAudiblePending = false;
};
